"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Milestone = void 0;
var vue_1 = require("vue");
var constants_1 = require("../constants");
var PreferencesManager_1 = require("./PreferencesManager");
exports.Milestone = vue_1.default.component('milestone', {
    props: {
        milestones_list: {
            type: Array,
        },
        show_scores: {
            type: Boolean,
            default: true,
        },
    },
    data: function () {
        var showDescription = {};
        for (var _i = 0, _a = this.milestones_list; _i < _a.length; _i++) {
            var milestone = _a[_i];
            showDescription[milestone.milestone.name] = false;
        }
        return {
            showList: true,
            showDescription: showDescription,
        };
    },
    methods: {
        getNameCss: function (milestoneName) {
            return ('ma-name ma-name--' + milestoneName.replace(/,/g, '').replace(/ /g, '-').toLowerCase());
        },
        shouldShow: function (milestone) {
            return this.showDescription[milestone.milestone.name] === true;
        },
        shouldShowList: function () {
            return this.showList;
        },
        toggle: function (milestone) {
            this.showDescription[milestone.milestone.name] = !this.showDescription[milestone.milestone.name];
        },
        toggleList: function () {
            this.showList = !this.showList;
        },
        getAvailableMilestoneSpots: function () {
            var count = this.milestones_list.filter(function (milestone) { return milestone.player_name; }).length;
            return Array(constants_1.MAX_MILESTONES - count).fill(constants_1.MILESTONE_COST);
        },
        isLearnerModeOn: function () {
            return PreferencesManager_1.PreferencesManager.load('learner_mode') === '1';
        },
    },
    template: "\n    <div class=\"milestones_cont\" v-trim-whitespace>\n        <div class=\"milestones\">\n            <div class=\"ma-title\">\n                <a class=\"ma-clickable\" href=\"#\" v-on:click.prevent=\"toggleList()\" v-i18n>Milestones</a>\n                <span v-for=\"milestone in milestones_list\" v-if=\"milestone.player_name\" class=\"milestone-award-inline paid\" :title=\"milestone.player_name\">\n                    <span v-i18n>{{ milestone.milestone.name }}</span>\n                    <span class=\"ma-player-cube\"><i :class=\"'board-cube board-cube--'+milestone.player_color\" /></span>\n                </span>\n                <span v-for=\"spotPrice in getAvailableMilestoneSpots()\" class=\"milestone-award-inline unpaid\" v-if=\"isLearnerModeOn()\">\n                    <div class=\"milestone-award-price\">{{spotPrice}}</div>\n                </span>\n            </div>\n            <div v-show=\"shouldShowList()\">\n                <div title=\"press to show or hide the description\" v-on:click.prevent=\"toggle(milestone)\" v-for=\"milestone in milestones_list\" :class=\"milestone.player_name ? 'ma-block pwned-item': 'ma-block'\">\n                    <div class=\"ma-player\" v-if=\"milestone.player_name\"><i :title=\"milestone.player_name\" :class=\"'board-cube board-cube--'+milestone.player_color\" /></div>\n                    <div class=\"ma-name--milestones\" :class=\"getNameCss(milestone.milestone.name)\" v-i18n>\n                        {{milestone.milestone.name}}\n                        <div v-if=\"show_scores\" class=\"ma-scores player_home_block--milestones-and-awards-scores\">\n                            <p v-for=\"score in milestone.scores.sort(\n                                (s1, s2) => s2.playerScore - s1.playerScore\n                            )\" :class=\"'ma-score player_bg_color_'+score.playerColor\">{{ score.playerScore }}</p>\n                        </div>\n                    </div>\n                    <div v-show=\"shouldShow(milestone)\" class=\"ma-description\" v-i18n>{{milestone.milestone.description}}</div>\n                </div>\n            </div>\n        </div>\n    </div>\n    ",
});
//# sourceMappingURL=Milestone.js.map